const set = require('regenerate')(0x205A);
set.addRange(0x10280, 0x1029C);
exports.characters = set;
